import { createRouter, createWebHistory } from 'vue-router'

import store from '@/store'

const routes = [
  {
    path: '',
    redirect: { name: 'CreateTransaction' }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: 'login' */ '@/views/login')
  },
  {
    path: '/transaction',
    component: () => import(/* webpackChunkName: 'transaction' */ '@/views/base'),
    children: [
      {
        path: '',
        redirect: () => ({ name: 'CreateTransaction' })
      },
      {
        path: 'create',
        name: 'CreateTransaction',
        meta: {
          parent: null,
          title: 'Create Transaction'
        },
        component: () => import(/* webpackChunkName: 'create-transaction' */ '@/views/transaction')
      },
      {
        path: 'detail/:id',
        name: 'DetailTransaction',
        meta: {
          parent: 'AllDocument',
          title: 'Detail Transaction'
        },
        component: () => import(/* webpackChunkName: 'create-transaction' */ '@/views/transaction')
      }
    ]
  },
  {
    path: '/document',
    component: () => import(/* webpackChunkName: 'document' */ '@/views/base'),
    children: [
      {
        path: '',
        redirect: () => ({ name: 'AllDocument' })
      },
      {
        path: 'all',
        name: 'AllDocument',
        meta: {
          parent: null,
          title: 'All Document'
        },
        component: () => import(/* webpackChunkName: 'all-document' */ '@/views/document')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.path !== '/login' && !store.getters['Auth/isAuthenticated']) {
    next({ name: 'Login', replace: true })
  } else if (to.path === '/login' && store.getters['Auth/isAuthenticated']) {
    next({ name: 'CreateTransaction', replace: true })
  } else {
    next()
  }
})

export default router
